import React from 'react';
import { Link } from 'react-router-dom';
import { HITLAB_PROFILE_READY_HOME_PATH } from './hitLabProfileReady';

const proofChips = [
  'Artist profile saved',
  'JG Player account ready',
  'Payment not started',
  'Record not in review yet',
];

export default function HitLabProfileReadyBridge({
  artistName = '',
  busy = false,
  onContinuePayment,
  onEditProfile,
  onUniverseClick,
  paymentPriceDisplay = '$9.99',
}) {
  const safeArtistName = String(artistName || '').trim();
  const heading = safeArtistName
    ? `${safeArtistName}, your JG HitLab Artist Profile is saved.`
    : 'Your JG HitLab Artist Profile is saved.';

  return (
    <section
      className="hitlab-form hitlab-profile-ready-bridge"
      aria-label="Profile Ready JG Universe bridge"
    >
      <div className="hitlab-post-submit-bridge-header">
        <div>
          <p className="hitlab-kicker">PROFILE READY</p>
          <h2>{heading}</h2>
          <p>
            Your record is not in review yet. Step into JG Universe, hear the
            Radio lane, then continue to the founding HitLab processing rate
            when you are ready.
          </p>
        </div>
        <Link
          className="hitlab-primary-btn"
          to={HITLAB_PROFILE_READY_HOME_PATH}
          onClick={onUniverseClick}
        >
          Enter JG Universe
        </Link>
      </div>

      <div className="hitlab-post-submit-proof-wrap">
        <p className="hitlab-post-submit-proof-label">Your current path</p>
        <ul
          className="hitlab-post-submit-proof"
          aria-label="HitLab profile ready proof"
        >
          {proofChips.map((chip) => (
            <li key={chip}>{chip}</li>
          ))}
        </ul>
      </div>

      <div className="hitlab-profile-ready-offers" aria-label="Profile ready next steps">
        <Link
          className="hitlab-profile-ready-offer"
          to={HITLAB_PROFILE_READY_HOME_PATH}
          onClick={onUniverseClick}
        >
          <span className="hitlab-profile-ready-eyebrow">JOE GALAXY RADIO</span>
          <strong>Hear Joe Galaxy Radio</strong>
          <span>
            Joe Galaxy Radio is live inside JG Universe.
          </span>
          <span>
            Hear records in rotation, see the artists behind them, and watch
            real listener activity and feedback take shape across the platform.
          </span>
          <span className="hitlab-profile-ready-offer-cta">
            Enter JG Universe + Hear Radio
          </span>
        </Link>

        <button
          type="button"
          className="hitlab-profile-ready-offer hitlab-profile-ready-offer-payment"
          disabled={busy}
          onClick={onContinuePayment}
        >
          <span className="hitlab-profile-ready-eyebrow">
            FOUNDING ARTIST RATE
          </span>
          <strong>Put One Record Through HitLab</strong>
          <span className="hitlab-profile-ready-price">
            Founding HitLab processing - {paymentPriceDisplay} one time
          </span>
          <span>
            Standard processing after the founding window: $19.99
          </span>
          <span>
            Every paid HitLab intake is personally heard by Joe Galaxy and
            receives a real curator response through a JG HitLab Listen Result.
          </span>
          <span>
            The strongest records can earn entry into Joe Galaxy Radio Rotation
            inside JG Universe.
          </span>
          <span className="hitlab-profile-ready-boundary">
            Payment gets the record processed. Placement cannot be bought. The
            record has to earn the next move.
          </span>
          <span className="hitlab-profile-ready-offer-cta">
            {busy ? 'Opening payment' : `Put My Record Through HitLab - ${paymentPriceDisplay}`}
          </span>
        </button>
      </div>

      <button
        type="button"
        className="hitlab-profile-ready-edit"
        onClick={onEditProfile}
      >
        Edit Artist Profile
      </button>
    </section>
  );
}
